import { TrendingUp, Droplets, Sprout, ListOrdered, Gift } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, SectionTitle, Highlight, Chevrons } from "./Primitives";

const POINTS = [
  [TrendingUp, "Why your income isn't turning into wealth", "The one thing wealthy people track that most salaried earners never look at."],
  [Droplets, "Find and plug your hidden money leaks", "See where your money quietly drains every month, and how to stop it."],
  [Sprout, "Make compounding work for you", "How small, consistent moves grow into a serious corpus over time."],
  [ListOrdered, "The right order to fix your finances", "Protection, cashflow, assets: get the order right and save years of trial and error."],
];

export const Learning = () => (
  <section className="px-4 pt-14 sm:pt-20 bg-white" data-testid="learning-section">
    <div className="max-w-5xl mx-auto">
      <Reveal>
        <SectionTitle>
          Here's What You Are Learning In <br className="hidden sm:block" />
          <Highlight>This Masterclass</Highlight>
        </SectionTitle>
      </Reveal>
      <div className="grid sm:grid-cols-2 gap-4 sm:gap-5 mt-8 sm:mt-10">
        {POINTS.map(([Icon, title, line], i) => (
          <Reveal key={title} delay={i * 0.08}>
            <motion.article
              whileHover={{ y: -4 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className="h-full rounded-2xl overflow-hidden bg-white border border-plum/10 shadow-[0_14px_40px_-24px_rgba(42,15,92,0.5)]"
              data-testid={`learning-point-${i + 1}`}
            >
              <header className="plum-band flex items-center gap-3 px-4 py-3 text-white">
                <Icon className="w-5 h-5 shrink-0" />
                <h3 className="font-bold text-[14.5px] sm:text-[15.5px] leading-snug">
                  <span className="opacity-80 mr-1">0{i + 1}.</span>{title}
                </h3>
              </header>
              <p className="px-4 py-3.5 text-[13.5px] sm:text-sm text-zinc-700 leading-relaxed">{line}</p>
            </motion.article>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1} className="mt-6">
        <div data-testid="surprise-box" className="flex items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-tang bg-orange-50 px-5 py-4 text-center">
          <Gift className="w-6 h-6 text-tang shrink-0" />
          <p className="font-bold text-ink text-[14px] sm:text-base">Plus a special surprise revealed ONLY to people who attend live.</p>
        </div>
      </Reveal>
      <Chevrons />
    </div>
  </section>
);
